document.addEventListener('DOMContentLoaded', () => {
  const quantityUpsellEls = document.querySelectorAll('.quantity-upsell [data-quantity]');

  quantityUpsellEls.forEach((quantityUpsell) => {
    quantityUpsell.addEventListener('click', (event) => {
      const quantity = event?.target?.dataset?.quantity;
      const quantityEl = document.querySelector('[action*="cart/add"] [name="quantity"]');

      if (quantity && quantityEl) {
        quantityEl.value = quantity;
        quantityEl.dispatchEvent(new Event('input'));
      }

      // 更新了这里的选择器以包含 customily-cart-btn
      const atc = document.querySelector('#teeAtcButton, [action*="cart/add"] [type="submit"], #customily-cart-btn');

      if (atc) {
        atc.scrollIntoView({ behavior: 'smooth', block: 'end' });
        setTimeout(() => {
          atc.click();
        }, 200);
      }
    });
  });
});


document.addEventListener('teeinblue-event-component-injected', () => {
  // moveElementAfter('.tee-product-price', '.shopify-app-block:has(> .jdgm-widget)');
  moveElementAfter('.tee-product-price', '.productView-title');
});
const moveElementAfter = (target, after) => {
  const targetEl = document.querySelector(target);
  const afterEl = document.querySelector(after);
  if (targetEl && afterEl) {
    afterEl.after(targetEl);
  }
};